"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _FHIGX2EEcjs = require('../__chunks/FHIGX2EE.cjs');


var _NSONUP5Ccjs = require('../__chunks/NSONUP5C.cjs');


var _FH6HQ5JNcjs = require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');





var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');





var _3BSDKDKDcjs = require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/form/form-label.tsx
var _focus = require('@ariakit/core/utils/focus');
var _misc = require('@ariakit/core/utils/misc');
var _react = require('react');
var _jsxruntime = require('react/jsx-runtime');
var TagName = "label";
function supportsNativeLabel(tagName) {
  return tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "meter" || tagName === "progress";
}
var useFormLabel = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useFormLabel2({
    store,
    name: nameProp,
    getItem: getItemProp,
    ...props
  }) {
    const context = _FHIGX2EEcjs.useFormContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "FormLabel must be wrapped in a Form component."
    );
    const id = _3BSDKDKDcjs.useId.call(void 0, props.id);
    const ref = _react.useRef.call(void 0, null);
    const name = String(nameProp);
    const getItem = _react.useCallback.call(void 0, 
      (item) => {
        const nextItem = { ...item, id: id || item.id, name, type: "label" };
        if (getItemProp) {
          return getItemProp(nextItem);
        }
        return nextItem;
      },
      [id, name, getItemProp]
    );
    const field = _FH6HQ5JNcjs.useStoreState.call(void 0, 
      store,
      (state) => state.items.find((item) => item.type === "field" && item.name === name)
    );
    const fieldTagName = _3BSDKDKDcjs.useTagName.call(void 0, field == null ? void 0 : field.element, "input");
    const isNativeLabel = supportsNativeLabel(fieldTagName);
    const onClickProp = props.onClick;
    const onClick = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
      onClickProp == null ? void 0 : onClickProp(event);
      if (event.defaultPrevented) return;
      if (isNativeLabel) return;
      const fieldElement = field == null ? void 0 : field.element;
      if (!fieldElement) return;
      queueMicrotask(() => {
        const focusableElement = _focus.getFirstTabbableIn.call(void 0, fieldElement, true, true);
        focusableElement == null ? void 0 : focusableElement.focus();
        const role = focusableElement == null ? void 0 : focusableElement.getAttribute("role");
        if (role === "combobox") return;
        focusableElement == null ? void 0 : focusableElement.click();
      });
    });
    props = {
      render: isNativeLabel ? /* @__PURE__ */ _jsxruntime.jsx.call(void 0, "label", {}) : /* @__PURE__ */ _jsxruntime.jsx.call(void 0, "span", {}),
      htmlFor: isNativeLabel ? field == null ? void 0 : field.id : void 0,
      ...props,
      id,
      ref: _3BSDKDKDcjs.useMergeRefs.call(void 0, ref, props.ref),
      onClick
    };
    if (!isNativeLabel) {
      props = {
        ...props,
        style: {
          cursor: "default",
          ...props.style
        }
      };
    }
    props = _NSONUP5Ccjs.useCollectionItem.call(void 0, { store, ...props, getItem });
    return props;
  }
);
var FormLabel = _PTOCUU2Dcjs.memo.call(void 0, 
  _PTOCUU2Dcjs.forwardRef.call(void 0, function FormLabel2(props) {
    const htmlProps = useFormLabel(props);
    return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
  })
);



exports.FormLabel = FormLabel; exports.useFormLabel = useFormLabel;
